module.exports = __webpack_public_path__ + "static/img/logo4.25bcb047.png";